import { memo } from 'react';
import { cn } from '@divlab/divanui';

import Img from '@UI/Img';
import styles from './InviteToGetInspired.module.css';

import type { FC, HTMLAttributes } from 'react';
import type { IInfo } from '@Pages/PageShowroom/typings';

export interface InviteToGetInspiredProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  info: IInfo;
}

const InviteToGetInspired: FC<InviteToGetInspiredProps> = (props) => {
  const { className, info, ...restProps } = props;
  const { blocks } = info;

  return (
    <div {...restProps} className={className}>
      <div>
        <h2 className={styles.blockTitle}>{info.title}</h2>
        <p className={styles.blockText}>{info.text}</p>
      </div>
      <div className={styles.contentBlock}>
        <div className={styles.contentBlockImages}>
          {blocks.uniqueSolutions.images.map((image, index) => {
            const imageClass = index === 0 ? styles.slimImage : styles.wideImage;
            return <Img className={imageClass} key={image} src={image} alt='' />;
          })}
        </div>
        <div className={styles.textBlock}>
          <h3 className={styles.contentBlockTitle}>{blocks.uniqueSolutions.title}</h3>
          <p className={styles.contentBlockText}>{blocks.uniqueSolutions.text}</p>
        </div>
      </div>
      <div className={styles.contentBlockDown}>
        <div className={styles.textBlock}>
          <h3 className={styles.contentBlockTitle}>{blocks.materials.title}</h3>
          <p className={styles.contentBlockText}>{blocks.materials.text}</p>
        </div>
        <div className={cn(styles.contentBlockImages, styles.evenBlock)}>
          {blocks.materials.images.map((image, index) => {
            const imageClass = index === 0 ? styles.slimImage : styles.wideImage;
            return <Img className={imageClass} key={image} src={image} alt='' />;
          })}
        </div>
      </div>
    </div>
  );
};

export default memo(InviteToGetInspired);
